<!-- ============================================================== -->
<section class="w-full bg-gray-100 pb-60 lg:pb-0">
    <!-- <div class="w-full h-160 relative bg-cover bg-no-repeat bg-center flex flex-col justify-center items-center bg-[url('https://www.xltravel.co.za/images/XL.jpg')]"> -->
    <div class="w-full min-h-[650px] relative bg-no-repeat  flex flex-col justify-center items-center transition-all duration-1000 bg-top bg-contain sm:bg-contain md:bg-top sm:bg-top xs:bg-contain  lg:bg-top xl:bg-cover"
     [ngStyle]="{'background-image': 'url(' + view.currentBackgroundImage + ')'}"
     >
        <!-- <div  *ngIf="view.site?.id !== 146" class="absolute inset-0 bg-gradient-to-r from-gray-800 via-gray-800/40"></div> -->
        <div class="w-[90%] h-full flex items-start">
            <!-- <div class="lg:w-fit z-10">
                <div
                    class="text-left text-white text-6xl tracking-wide font-bold custom_font"
                >
                    <h1>{{ this.view.site?.slogan }}</h1>
                    <h1>Seeing the World By</h1>
                    <h1>Traveling.</h1>
                </div>
                <p class="text-md max-w-128 text-white p-2 leading-6">
                    Making your dream to see the world come true is a thrilling
                    and enriching goal. Traveling allows you to experience new
                    cultures, cuisines, landscapes, and ways of life, broadening
                    your perspectives and creating unforgettable memories
                </p>
                <button
                    class="mt-3 rounded font-bold text-primary-100 py-4 px-6 transition bg-primary-500 transition-duration: 500ms hover:bg-primary-100 hover:text-primary-500"
                >
                    Book Your Stay
                </button>
            </div> -->
            <ejs-carousel [showIndicators]="false" [buttonsVisibility]="'VisibleOnHover'" [partialVisible]="false"
                [interval]=3000 (slideChanged)="onCarouselChange($event)">
                <e-carousel-items>
                    <e-carousel-item>
                        <ng-template #template>
                            <figure class="img-container ">
                                <div class="w-full px-2"></div>
                                <div class="w-full px-2 hidden">
                                    <div class="text-left text-white text-6xl tracking-wide font-bold custom_font">
                                        @if (view.site && view.site.profile && view.site.profile.heading) {
                                        @switch (view.site.profile.heading.banner) {
                                        @case (1) {
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Beyond The </h1>
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Ordinary</h1>
                                        }
                                        @case (2) {
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Beyond The </h1>
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Ordinary</h1>
                                        }
                                        @case (3) {
                                        <div class="flex flex-col items-center m-auto">
                                            <h1 class="font-extrabold uppercase italic font-sans text-7xl text-center">
                                                3-Nts Iconic Aegean</h1>
                                            <div class="flex gap-2 mt-4">
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'FLIGHT'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:flight"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'HOTEL'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:house"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'CRUISE'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:directions_boat_filled"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'TRANSFERS'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:directions_car"></mat-icon>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        }
                                        }

                                    </div>
                                    @if (view.site && view.site.profile && view.site.profile.heading) {
                                    @switch (view.site.profile.heading.banner) {
                                    @case (1) {
                                    <div class="flex items-baseline">
                                        <span class="w-26 ml-1 border-b-8 border-primary-500"></span>
                                        <span class="w-4 ml-1 border-b-8 border-primary-500"></span>
                                        <span class="w-4 ml-1 border-b-8 border-primary-500"></span>
                                    </div>
                                    }
                                    @case (2) {
                                    <div class="max-w-72">
                                        <img src="assets/xltravel/swoosh-01.svg" alt="Swoosh">
                                    </div>
                                    }
                                    }
                                    }
                                    @if (view.site && view.site.profile && view.site.profile.heading) {
                                    @switch (view.site.profile.heading.banner) {
                                    @case (1) {
                                    <div class="mb-20">
                                        <p class="text-md  max-w-128 text-white p-2 leading-6 mb-8"> XL Travel ensures
                                            that
                                            the Group’s procurement benefits, integrated with the entrepreneurial flair
                                            of
                                            its owner managed operations, provides both the corporate and leisure
                                            clients
                                            with the very best in service delivery and price as well as providing and
                                            supporting intelligent travel solutions.
                                        </p>
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-primary-500 py-4 px-6 transition bg-accent-500 transition-duration: 500ms hover:bg-accent-700">
                                            FIND AN XL TRAVEL OFFICE </a>
                                    </div>
                                    }
                                    @case (2) {
                                    <div class="mb-20">
                                        <p class="text-md  max-w-128 text-white p-2 leading-6 mb-8">
                                            XL Travel ensures that the Group’s procurement benefits, integrated with the
                                            entrepreneurial flair of its owner-managed operations, provides both the
                                            corporate and leisure clients with the very best in service delivery and
                                            price, as well as providing and supporting intelligent travel solutions.
                                        </p>
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-primary-500 py-4 px-6 transition bg-accent-500 transition-duration: 500ms hover:bg-accent-700">
                                            FIND AN XL TRAVEL OFFICE
                                        </a>
                                    </div>
                                    }
                                    @case (3) {
                                    <p class="text-md  max-w-128 text-white p-2 leading-6 mb-4"> XL Travel ensures that
                                        the Group’s procurement benefits.
                                    </p>
                                    <div class="flex justify-center mb-4">
                                        <div class="flex flex-row justify-between mt-0">
                                            <div>
                                                <span class="text-primary-500 text-3xl font-bold"> R 2000</span><sub
                                                    class="mx-1">pps</sub>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-row divide-x justify-center divide-gray-300">
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="mat_outline:directions_boat_filled"></mat-icon>
                                            <p class="text-white text-sm font-light">Celestyal Discovery</p>
                                        </div>
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="heroicons_solid:star"></mat-icon>
                                            <p class="text-white text-md font-light">Athens to Athens</p>
                                        </div>
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="mat_outline:date_range"></mat-icon>
                                            <p class="text-white text-sm font-light">1 - 4 Nov 2024</p>
                                        </div>
                                    </div>

                                    <div class="flex justify-center">
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-white py-3 px-6 transition bg-primary-500 hover:bg-accent-700 uppercase text-center">
                                            view details
                                        </a>
                                    </div>
                                    }
                                    }
                                    }
                                </div>
                                <figcaption class="img-caption hidden"></figcaption>
                            </figure>
                        </ng-template>
                        
                    </e-carousel-item>
                    <e-carousel-item>
                        <ng-template #template>
                            <figure class="img-container hidden">
                                <div class="w-full px-2">
                                    <div class="text-left text-white text-6xl tracking-wide font-bold custom_font">
                                        @if (view.site && view.site.profile && view.site.profile.heading) {
                                        @switch (view.site.profile.heading.banner) {
                                        @case (1) {
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Corporate Travel
                                        </h1>
                                        <!-- <h1 class="font-extrabold uppercase italic font-sans text-7xl">Ordinary</h1> -->
                                        }
                                        @case (2) {
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Corporate Travel
                                        </h1>
                                        <!-- <h1 class="font-extrabold uppercase italic font-sans text-7xl">Ordinary</h1> -->
                                        }
                                        @case (3) {
                                        <div class="flex flex-col items-center m-auto">
                                            <h1 class="font-extrabold uppercase italic font-sans text-7xl text-center">
                                                3-Nts Iconic Aegean</h1>
                                            <div class="flex gap-2 mt-4">
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'FLIGHT'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:flight"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'HOTEL'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:house"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'CRUISE'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:directions_boat_filled"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'TRANSFERS'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:directions_car"></mat-icon>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        }
                                        }

                                    </div>
                                    @if (view.site && view.site.profile && view.site.profile.heading) {
                                    @switch (view.site.profile.heading.banner) {
                                    @case (1) {
                                    <div class="flex items-baseline">
                                        <span class="w-26 ml-1 border-b-8 border-primary-500"></span>
                                        <span class="w-4 ml-1 border-b-8 border-primary-500"></span>
                                        <span class="w-4 ml-1 border-b-8 border-primary-500"></span>
                                    </div>
                                    }
                                    @case (2) {
                                    <div class="max-w-72">
                                        <img src="assets/xltravel/swoosh-01.svg" alt="Swoosh">
                                    </div>
                                    }
                                    }
                                    }
                                    @if (view.site && view.site.profile && view.site.profile.heading) {
                                    @switch (view.site.profile.heading.banner) {
                                    @case (1) {
                                    <div class="mb-20">
                                        <p class="text-md  max-w-128 text-white p-2 leading-6 mb-8">We understand the
                                            challenges facing our discerning travelers in this competitive marketplace
                                            and
                                            cater for special demands, with exceptional savings on hotels, cars, airfare
                                            and
                                            innovative technology solutions. We help clients improve efficiency and
                                            drive
                                            policy compliance while dedicated consultants (not a call centre) offer
                                            exceptional customer care, unmatched in the travel industry.
                                        </p>
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-primary-500 py-4 px-6 transition bg-accent-500 transition-duration: 500ms hover:bg-accent-700 uppercase">
                                            Read more </a>
                                    </div>
                                    }
                                    @case (2) {
                                    <div class="mb-20">
                                        <p class="text-md  max-w-128 text-white p-2 leading-6 mb-8"> We understand the
                                            challenges facing our discerning travelers in this competitive marketplace
                                            and
                                            cater for special demands, with exceptional savings on hotels, cars, airfare
                                            and
                                            innovative technology solutions. We help clients improve efficiency and
                                            drive
                                            policy compliance while dedicated consultants (not a call centre) offer
                                            exceptional customer care, unmatched in the travel industry.
                                        </p>
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-primary-500 py-4 px-6 transition bg-accent-500 transition-duration: 500ms hover:bg-accent-700 uppercase">
                                            Read more</a>
                                    </div>
                                    }
                                    @case (3) {
                                    <p class="text-md  max-w-128 text-white p-2 leading-6 mb-4"> XL Travel ensures that
                                        the Group’s procurement benefits.
                                    </p>
                                    <div class="flex justify-center mb-4">
                                        <div class="flex flex-row justify-between mt-0">
                                            <div>
                                                ><span class="text-primary-500 text-3xl font-bold"> R 2000</span><sub
                                                    class="mx-1">pps</sub>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-row divide-x justify-center divide-gray-300">
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="mat_outline:directions_boat_filled"></mat-icon>
                                            <p class="text-white text-sm font-light">Celestyal Discovery</p>
                                        </div>
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="heroicons_solid:star"></mat-icon>
                                            <p class="text-white text-md font-light">Athens to Athens</p>
                                        </div>
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="mat_outline:date_range"></mat-icon>
                                            <p class="text-white text-sm font-light">1 - 4 Nov 2024</p>
                                        </div>
                                    </div>

                                    <div class="flex justify-center">
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-white py-3 px-6 transition bg-primary-500 hover:bg-accent-700 uppercase text-center">
                                            view details
                                        </a>
                                    </div>
                                    }
                                    }
                                    }
                                </div>
                                <figcaption class="img-caption"></figcaption>
                            </figure>
                        </ng-template>
                    </e-carousel-item>
                    <e-carousel-item>
                        <ng-template #template>
                            <figure class="img-container hidden">
                                <div class="w-full px-2">
                                    <div class="text-left text-white text-6xl tracking-wide font-bold custom_font">
                                        @if (view.site && view.site.profile && view.site.profile.heading) {
                                        @switch (view.site.profile.heading.banner) {
                                        @case (1) {
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Leisure Travel
                                        </h1>
                                        <!-- <h1 class="font-extrabold uppercase italic font-sans text-7xl">Ordinary</h1> -->
                                        }
                                        @case (2) {
                                        <h1 class="font-extrabold uppercase italic font-sans text-7xl">Leisure Travel
                                        </h1>
                                        <!-- <h1 class="font-extrabold uppercase italic font-sans text-7xl">Ordinary</h1> -->
                                        }
                                        @case (3) {
                                        <div class="flex flex-col items-center m-auto">
                                            <h1 class="font-extrabold uppercase italic font-sans text-7xl text-center">
                                                3-Nts Iconic Aegean</h1>
                                            <div class="flex gap-2 mt-4">
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'FLIGHT'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:flight"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'HOTEL'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:house"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'CRUISE'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:directions_boat_filled"></mat-icon>
                                                </div>
                                                <div class="ring-gray-200 rounded-full ring-1 w-6 h-6 p-1 flex justify-center items-center"
                                                    [matTooltip]="'TRANSFERS'">
                                                    <mat-icon class="icon-size-4 text-gray-200"
                                                        svgIcon="mat_outline:directions_car"></mat-icon>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        }
                                        }

                                    </div>
                                    @if (view.site && view.site.profile && view.site.profile.heading) {
                                    @switch (view.site.profile.heading.banner) {
                                    @case (1) {
                                    <div class="flex items-baseline">
                                        <span class="w-26 ml-1 border-b-8 border-primary-500"></span>
                                        <span class="w-4 ml-1 border-b-8 border-primary-500"></span>
                                        <span class="w-4 ml-1 border-b-8 border-primary-500"></span>
                                    </div>
                                    }
                                    @case (2) {
                                    <div class="max-w-72">
                                        <img src="assets/xltravel/swoosh-01.svg" alt="Swoosh">
                                    </div>
                                    }
                                    }
                                    }
                                    @if (view.site && view.site.profile && view.site.profile.heading) {
                                    @switch (view.site.profile.heading.banner) {
                                    @case (1) {
                                    <div class="mb-20">
                                        <p class="text-md  max-w-128 text-white p-2 leading-6 mb-8">When it comes to
                                            creating the perfect getaway, trying to save money can come at a huge cost.
                                            Let
                                            our leisure experts find and plan your next adventure, giving you complete
                                            peace
                                            of mind. Our specialists can tap into years of expertise to save you time
                                            and
                                            stress. XL Travel’s unique insight, knowledge and experience can’t be found
                                            in
                                            the pages of travel magazines or even on the net - it’s all ours. And yours.
                                        </p>
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-primary-500 py-4 px-6 transition bg-accent--500 transition-duration: 500ms hover:bg-accent-700 uppercase ">read
                                            more </a>
                                    </div>
                                    }
                                    @case (2) {
                                    <div class="mb-20">
                                        <p class="text-md  max-w-128 text-white p-2 leading-6 mb-8">When it comes to
                                            creating the perfect getaway, trying to save money can come at a huge cost.
                                            Let
                                            our leisure experts find and plan your next adventure, giving you complete
                                            peace
                                            of mind. Our specialists can tap into years of expertise to save you time
                                            and
                                            stress. XL Travel’s unique insight, knowledge and experience can’t be found
                                            in
                                            the pages of travel magazines or even on the net - it’s all ours. And yours.
                                        </p>
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-primary-500 py-4 px-6 transition bg-accent-500 transition-duration: 500ms hover:bg-accent-700 uppercase">
                                            read more</a>
                                    </div>
                                    }
                                    @case (3) {
                                    <p class="text-md  max-w-128 text-white p-2 leading-6 mb-4"> XL Travel ensures that
                                        the Group’s procurement benefits.
                                    </p>
                                    <div class="flex justify-center mb-4">
                                        <div class="flex flex-row justify-between mt-0">
                                            <div>
                                                <span class="text-primary-500 text-3xl font-bold"> R 2000</span><sub
                                                    class="mx-1">pps</sub>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-row divide-x justify-center divide-gray-300">
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="mat_outline:directions_boat_filled"></mat-icon>
                                            <p class="text-white text-sm font-light">Celestyal Discovery</p>
                                        </div>
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="heroicons_solid:star"></mat-icon>
                                            <p class="text-white text-md font-light">Athens to Athens</p>
                                        </div>
                                        <div class="flex flex-row items-center justify-center px-4">
                                            <mat-icon class="icon-size-4 mr-2 text-primary-500"
                                                svgIcon="mat_outline:date_range"></mat-icon>
                                            <p class="text-white text-sm font-light">1 - 4 Nov 2024</p>
                                        </div>
                                    </div>

                                    <div class="flex justify-center">
                                        <a routerLink="branches"
                                            class="mt-3 rounded font-bold text-white py-3 px-6 transition bg-primary-500 hover:bg-accent-700 uppercase text-center">
                                            view details
                                        </a>
                                    </div>
                                    }
                                    }
                                    }
                                </div>
                                <figcaption class="img-caption"></figcaption>
                            </figure>
                        </ng-template>
                    </e-carousel-item>

                </e-carousel-items>

                <!-- <ng-template #previousButtonTemplate let-data>
                    <button type="button"
                        class="disabled:pointer-events-none absolute -ml-8 inset-y-0 start-0 inline-flex justify-center items-center w-[46px] h-full text-primary-800  focus:outline-none focus:bg-primary-800/10 rounded-s-lg dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10">
                        <span
                            class="text-2xl bg-accent-500 hover:bg-accent-700 transition ease-out duration-500 border-none rounded-full "
                            aria-hidden="true">
                            <svg class="shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m15 18-6-6 6-6"></path>
                            </svg>
                        </span>
                        <span class="sr-only">Previous</span>
                    </button>
                </ng-template>
                <ng-template #nextButtonTemplate let-data>
                    <button type="button"
                        class="disabled:pointer-events-none absolute -mr-8 inset-y-0 end-0 inline-flex justify-center items-center w-[46px] h-full text-primary-800  focus:outline-none focus:bg-primary-800/10 rounded-e-lg dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10">
                        <span class="sr-only">Next</span>
                        <span
                            class="text-2xl bg-accent-500 hover:bg-accent-700 transition ease-out duration-500 border-none rounded-full"
                            aria-hidden="true">
                            <svg class="shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </span>
                    </button>
                </ng-template> -->
            </ejs-carousel>
        </div>

        <!-- <app-slide-banner-type01 class="w-full"></app-slide-banner-type01> -->

        @if (view.site && view.site.profile && view.site.profile.sections) {
        @switch (view.site.profile.sections.searchwidget) {
        @case (1) {
        <div class="lg:-mb-40 md:-mb-72 w-[90%] rounded-t-lg m-auto z-10 right-0 -mb-60 mt-vh bottom-0 translate-y-[30%]">

            <ul class="flex  justify-start md:justify-center -mb-px text-sm p-4 font-medium text-center bg-white  w-full  overflow-x-auto"
                id="default-styled-tab" role="tablist">

                <li class=" me-2">
                    <button
                        class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="fights-tab" [class.active]="view.selectedTab === 'flight'" (click)="selectTab('flight')"
                        type="button" role="tab" aria-controls="flights" aria-selected="true" [disabled]="false">
                        <!-- <mat-icon role="img" class="mat-icon notranslate fuse-vertical-navigation-item-icon mat-icon-no-color ng-star-inserted" aria-hidden="true" ng-reflect-svg-icon="mat_outline:directions_boat" data-mat-icon-type="svg" data-mat-icon-name="directions_boat" data-mat-icon-namespace="mat_outline"><svg viewBox="0 0 24 24" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M13 3v1h-2V3h2m-1 7.11l5.38 1.77 2.39.78-1.12 3.97c-.54-.3-.94-.71-1.14-.94L16 13.96l-1.51 1.72c-.34.4-1.28 1.32-2.49 1.32s-2.15-.92-2.49-1.32L8 13.96l-1.51 1.72c-.2.23-.6.63-1.14.93l-1.13-3.96 2.4-.79L12 10.11M15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"></path></svg></mat-icon> -->
                        Flights
                    </button>
                </li>
                <!-- <li class="me-2">
                    <button
                        class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="hotels-tab" [class.active]="view.selectedTab === 'hotel'" (click)="selectTab('hotel')"
                        type="button" role="tab" aria-controls="hotels" aria-selected="view.selectedTab === 'hotel'"
                        [disabled]="false">
                        Hotels
                    </button>
                </li> -->
                <li class="me-2">
                    <button
                        class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition transition-duration: 500ms [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="Packages-tab" [class.active]="view.selectedTab === 'package'" (click)="selectTab('package')"
                        type="button" role="tab" aria-controls="packages" aria-selected="view.selectedTab === 'package'"
                        [disabled]="false">
                        Packages
                    </button>
                </li>
                <!-- <li class="me-2">
                    <button class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                        [matTooltip]="'Coming Soon!'" id="cars-tab" [class.active]="view.selectedTab === 'car'"
                        (click)="selectTab('car')" type="button" role="tab" aria-controls="cars"
                        aria-selected="view.selectedTab === 'car'" [disabled]="true">
                        Cars
                    </button>
                </li>
                <li class="me-2">
                    <button class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                        [matTooltip]="'Coming Soon!'" id="transfers-tab"
                        [class.active]="view.selectedTab === 'transfer'" (click)="selectTab('transfer')" type="button"
                        role="tab" aria-controls="transfers" aria-selected="view.selectedTab === 'transfer'"
                        [disabled]="true">
                        Transfers
                    </button>
                </li>
                <li class="me-2">
                    <button class="inline-block px-5 py-2 rounded-md hover:text-primary-500 uppercase text-hint"
                        id="transfers-tab" [matTooltip]="'Coming Soon!'" [class.active]="view.selectedTab === 'cruises'"
                        (click)="selectTab('hotel')" type="button" role="tab" aria-controls="transfers"
                        aria-selected="view.selectedTab === 'transfer'" [disabled]="true">
                        Cruises
                    </button>
                </li> -->

                <!-- <li class="me-2">
                                <button class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white hover:text-black  uppercase" id="activities-tab" [class.active]="view.selectedTab === 'activities'" (click)="selectTab('activities')" type="button" role="tab" aria-controls="activities" aria-selected="view.selectedTab === 'activities'">Activities</button>
                            </li>
                            <li class="me-2">
                                <button class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white hover:text-black  uppercase" id="cruises-tab" [class.active]="view.selectedTab === 'cruises'" (click)="selectTab('cruises')" type="button" role="tab" aria-controls="cruises" aria-selected="view.selectedTab === 'cruises'">Cruises</button>
                            </li> -->
            </ul>
            
            <div id="default-styled-tab-content" class="bg-white shadow-2xl ">
                @if (view.selectedTab === 'flight') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'flight' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'hotel') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'stay' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                    <!-- <stay-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></stay-list> -->
                </div>
                } @if (view.selectedTab === 'package') {
                <div class="md:rounded-lg">
                    <!-- <search-widget [panel]="{ type: 'package' }" (tripChange)="tripChanged($event)" (searchChange)="searchChanged($event)"></search-widget> -->
                    <search-widget [cacheMode]="view.cacheMode" (tripChange)="tripChanged($event)" (searchChange)="searchChanged($event)" [panel]="{type: 'package'}"></search-widget>
                </div>
                } @if (view.selectedTab === 'car') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'car' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'transfer') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'transfer' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'activity') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'activity' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'cruise') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'cruise' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                }
                <div class="pb-26 md:pb-26 lg:pb-0 xl:pb-0" *ngIf="view.selectedTab === 'hotel'">

                </div>
            </div>
        </div>
        }
        }
        }
    </div>

</section>
